"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionConfirmationComponent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const newsletter_suscription_confirmation_1 = require("@ariessolutionsio/react-ecomm-ui/dist/components/PageSections/marketing/newsletter-suscription/newsletter-suscription-confirmation");
const SubscriptionConfirmationComponent = (props) => {
    return ((0, jsx_runtime_1.jsx)("div", { className: "min-h-[235px] w-full bg-[#FFF6EA] p-10", children: (0, jsx_runtime_1.jsx)(newsletter_suscription_confirmation_1.NewsletterSubscriptionConfirmation, { ...props }) }));
};
exports.SubscriptionConfirmationComponent = SubscriptionConfirmationComponent;
